import { useState, useEffect } from "react"
import Box from "@mui/material/Box"
import InputLabel from "@mui/material/InputLabel"
import MenuItem from "@mui/material/MenuItem"
import FormControl from "@mui/material/FormControl"
import Select from "@mui/material/Select"
import { useDispatch, useSelector } from "react-redux"
import { getCategories } from "../../redux/apiCalls"

const DropdownMenu = ({ handleChangeForm }) => {
  const [category, setCategory] = useState([])
  const dispatch = useDispatch()
  const categories = useSelector((store) => store.category.categories)

  useEffect(() => {
    getCategories(dispatch)
  }, [])

  const changeSelectValue = (e) => {
    setCategory(e.target.value)
  }

  return (
    <Box sx={{ minWidth: 120 }}>
      <FormControl fullWidth>
        <InputLabel id='demo-simple-select-label'>Category</InputLabel>
        <Select
          labelId='demo-simple-select-label'
          id='demo-simple-select'
          value={category}
          name='categories'
          multiple
          variant='standard'
          onChange={(e) => {
            handleChangeForm(e)
            changeSelectValue(e)
          }}>
          {categories &&
            categories.map((category) => {
              return (
                <MenuItem value={category.id} key={category.id}>
                  {category.name}
                </MenuItem>
              )
            })}
        </Select>
      </FormControl>
    </Box>
  )
}
export default DropdownMenu
